import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Popover, Button } from '@mui/material';
import Tooltip from '@src/components/Tooltip';
import { StyledSelectionButton, StyledMenuItem } from './index.style';
import NewUiSelectionType from './NewUiSelectionType';

const SelectionButtonNew = ({
  currentValue,
  name,
  tooltipTitle,
  icon,
  text,
  options = [],
  width,
  disabled,
  onChange,
  handleCloseSearchBoxAndMoreMenu,
  handleCloseSearchBox,
  isMoreButton,
  openAttribute,
  attribute,
  useNewUiChangeType,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const { t } = useTranslation();

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
    if (isMoreButton) handleCloseSearchBox();
    else handleCloseSearchBoxAndMoreMenu();
  };
  const handleClose = () => setAnchorEl(null);

  const handleChange = (value) => {
    handleClose();
    if (onChange) onChange(name, value);
  };

  const AUDIO_ATTRIBUTES = {
    BITRATE: 'bitrate',
    AUDIO_TYPE: 'audioType',
  };

  if (useNewUiChangeType)
    return (
      <NewUiSelectionType
        options={options}
        currentValue={currentValue}
        handleChange={handleChange}
        icon={icon}
        tooltipTitle={tooltipTitle}
      />
    );

  return (
    <StyledSelectionButton
      width={width}
      active={!!anchorEl}
      disabled={disabled}
    >
      <Tooltip arrow title={t(tooltipTitle)} placement="top">
        <Button
          className="custom-button"
          onClick={handleClick}
          data-id={openAttribute}
        >
          {typeof icon === 'string' ? (
            <img src={icon} alt={name} className="button-img" />
          ) : (
            icon
          )}
          <Typography variant="body2" className="toolbar-text">
            <span>{currentValue}</span> {text && ` ${text}`}
          </Typography>
        </Button>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {options.map((item) => (
          <StyledMenuItem
            key={item}
            active={currentValue === item}
            onClick={() => handleChange(item)}
            data-id={attribute}
            {...(name === AUDIO_ATTRIBUTES.BITRATE && { 'data-bitrate': item })}
            {...(name === AUDIO_ATTRIBUTES.AUDIO_TYPE && {
              'data-audio-type': item,
            })}
          >
            <Typography variant="body2" className="text">
              <span>{t(item)}</span> {text && ` ${text}`}
            </Typography>
          </StyledMenuItem>
        ))}
      </Popover>
    </StyledSelectionButton>
  );
};
export default SelectionButtonNew;
